<template>
    <div class="field-container"  :class="class_width">
        <label :for="'booking_cms_select_' + config.value" :style="getStylesLabel">{{ config.label }}</label>
        <select :id="'booking_cms_select_' + config.value"  v-model="inputValue" :style="[getStylesSelect ]">
            <option v-for="(n , index) in getRange.maxRange" :value="index + getRange.minRange">{{ String(index + getRange.minRange) + ' ' + config.labelSelect }}</option>
        </select>
    </div>
</template>

<script>

    export default{
        // 1-5
        name: 'BookingSelect',
        props:{
            attributes: Object,
            config: Object,
            icon: String,
            class_width:String
        },
        computed:{
            getRange(){
             
                let range = this.config.range.split('-')

                let maxRange = parseInt(range[1] - range[0] + 1);

                if( range[1] < range[0] ){
                    maxRange = range[1]
                }

                return {
                    minRange: parseInt(range[0]),
                    maxRange: maxRange
                }
            },
            getStylesLabel(){
                const  {  border  , backgroundColor , fontSizeLabel , fontSizeLabelInside , fontSize , padding , ...rest } = this.attributes
                const paddings = padding.split(' ')
                if( this.attributes['label-inside'] ){
                    return {
                        ...rest,
                        fontSize: fontSizeLabel,
                        position: 'absolute',
                        transition: 'all 0.2s ease',
                        top: paddings[0],
                        left: paddings[3],
                        pointerEvents: 'none',
                    }
                }else{
                    return { 
                        ...rest,
                        fontSize: fontSizeLabel,
                        textAlign: 'left',

                    }
                }
            },
            getStylesSelect(){
                const { border , lineHeight , fontSizeLabel , fontSizeLabelInside , ...rest } = this.attributes
                return{
                    ...rest,
                    backgroundImage: `url(${this.icon})`,
                    backgroundSize: 'auto 8px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPositionY: 'center',
                    backgroundPositionX: 'calc(100% - 15px)',
                    borderTop: border.top,
                    borderBottom: border.bottom,
                    borderRight: border.right,
                    borderLeft: border.left,
                }
            }
        },
        data(){
            return{
                inputValue: 0
            }
        },
        mounted(){
            //this.inputValue = this.attributes['label-inside'] ? -1 : this.getRange.minRange
            this.inputValue = this.getRange.minRange
        },
        watch:{
            inputValue:function(){
                this.$parent.$parent.$emit('update-data' , {
                    [this.config.value] : this.inputValue.toString()
                })
            }
        }
       
    }

</script>